<template>
  <section>
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      v-b-toggle="'matter-order-judgment-' + buttonType"
      :variant="buttonType === 'sm' ? 'outline-success' : 'success'"
      :class="buttonType === 'sm' ? 'btn-sm' : 'mb-75'"
      block
      @click="fetchJudgment"
    >
      {{ buttonType === 'sm' ? 'Orders' : 'Order/Judgment' }}
    </b-button>

    <!-- Sidebar -->
    <b-sidebar
      :id="'matter-order-judgment-' + buttonType"
      sidebar-class="sidebar-lg"
      bg-variant="white"
      shadow
      backdrop
      right
    >
      <template #header="{ hide }">
        <b-col>
          <b-row class="justify-content-between px-1 py-1">
            <h5 class="mb-0">Orders & Judgment</h5>
            <feather-icon
              class="ml-1 cursor-pointer"
              icon="XIcon"
              size="16"
              @click="hide"
            />
          </b-row>
          <p style="font-size: 10px; line-height: 2" class="p-0 m-0">
            Disclaimer: This Information is based on the Data Fetched From the
            Website of the Court. There may be some mistakes/omissions.
            Counsels may refer to the official website for verifying data.
          </p>
        </b-col>
      </template>

      <template #default="{ hide }">
        <b-row align-v="stretch">
          <b-col d-flex justify-center align-center>
            <b-overlay
              :show="$store.state.matterStore.judgmentLoading"
              rounded="sm"
              variant="transparent"
              opacity="0.5"
              blur="2px"
            >
              <!-- Judgment List -->
              <div v-if="$store.state.matterStore.judgmentList.length">
                <b-list-group>
                  <div
                    v-for="(item, index) in $store.state.matterStore.judgmentList"
                    :key="item._id"
                  >
                    <b-list-group-item
                      @click="previewJudgment(item)"
                      class="d-flex justify-content-between align-items-center cursor-pointer"
                    >
                      <b-row class="align-items-center">
                        <b-avatar variant="secondary" class="ml-1" size="2rem">
                          <feather-icon icon="FileTextIcon" />
                        </b-avatar>
                        <span class="ml-1">
                          {{ formatDate(item.datetime, { month: 'short', day: 'numeric', year: 'numeric' }) }}
                        </span>
                      </b-row>

                      <b-badge variant="primary" pill class="badge-round">
                        <feather-icon
                          :id="`invoice-row-${item._id}-preview-icon`"
                          icon="Link2Icon"
                          size="16"
                          class="mr-25"
                        />
                        <span>Preview</span>
                      </b-badge>
                    </b-list-group-item>
                  </div>
                </b-list-group>
              </div>

              <h6
                v-if="!$store.state.matterStore.judgmentList.length && !$store.state.matterStore.judgmentLoading"
                class="text-center mt-2"
              >
                Judgment Not Available!
              </h6>
            </b-overlay>
          </b-col>
        </b-row>
      </template>

      <template #footer>
        <b-row class="px-1 py-1 justify-content-around">
          <ExportAllJudgmentButton
            :matter_id="matter._id"
            :unique_id="matter.unique_id"
          />
          <RefreshJudgmentButton
            :matter_id="matter._id"
            :unique_id="matter.unique_id"
          />
        </b-row>
      </template>
    </b-sidebar>
  </section>
</template>

<script>
import {
  BSidebar,
  BButton,
  BBadge,
  BRow,
  BCol,
  BListGroup,
  BAvatar,
  BListGroupItem,
  VBToggle,
  BOverlay
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { formatDate } from '@core/utils/filter'
import ExportAllJudgmentButton from './ExportAllJudgmentButton.vue'
import RefreshJudgmentButton from './RefreshJudgmentButton'

export default {
  components: {
    BSidebar,
    BButton,
    BBadge,
    BRow,
    BCol,
    BAvatar,
    BOverlay,
    BListGroup,
    BListGroupItem,
    ExportAllJudgmentButton,
    RefreshJudgmentButton
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle
  },
  props: {
    data: { default: null },
    type: { default: 'lg' }
  },
  data() {
    return {
      matter: this.data,
      buttonType: this.type
    }
  },
  methods: {
    fetchJudgment() {
      this.$store.dispatch('matterStore/fetchMatterJudgment', this.matter._id)
    },

    previewJudgment(item) {
      let uu = item.reference_id.includes('-')
        ? item.reference_id.split('-').slice(2).join('/')
        : item.reference_id
      let dd = item.datetime.toString().split('T')[0]

      let href = item.url.replace(
        'http://s3.mymunshi.live',
        'https://app.mymunshi.in/exports'
      )

      // 👉 Open in new tab instead of modal
      window.open(href, '_blank')
    }
  },
  setup() {
    return { formatDate }
  }
}
</script>
